'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.slugify = exports.createUniqueUuidFromString = undefined;

var _sign = require('babel-runtime/core-js/math/sign');

var _sign2 = _interopRequireDefault(_sign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable */
var uniqueUuids = {};
var createUniqueUuidFromString = function createUniqueUuidFromString(str, retry) {
  function hashToInt(str) {
    var hash = 0;

    if (typeof str === 'undefined' || str.length === 0) {
      return hash;
    }
    for (var i = 0; i < str.length; i++) {
      var chr = str.charCodeAt(i);
      hash = (hash << 5) - hash + chr;
      hash |= 0; // Convert to 32bit integer
    }
    hash *= (0, _sign2.default)(hash);
    hash = Math.sqrt(hash);
    hash = Math.floor((hash - Math.floor(hash)) * 1000000);

    return hash;
  }

  var num = hashToInt(str);

  var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c, i) {
    var r = Math.ceil(num / (i + 1)) % 16,
        v = c == 'x' ? r : r & 0x3 | 0x8;
    return v.toString(16);
  });
  // console.log('Generated uuid & number from string', num, uuid, str);

  if (uniqueUuids[uuid]) {
    //unique uuid already exists!
    console.warn('Pro Gallery - unique uuid already exists', num, retry, { old: uniqueUuids[uuid], new: num });
    if (typeof retry === 'undefined' || retry > 0) {
      return createUniqueUuidFromString(str + 'x', (retry || 10) - 1);
    } else {
      console.error('Pro Gallery - cannot create unique uuid', str, num);
      return uuid;
    }
  } else {
    uniqueUuids[uuid] = num;
    return uuid;
  }
};

var slugify = function slugify() {
  var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  return text.toString().toLowerCase().replace(/\s+/g, '-') // Replace spaces with -
  .replace(/[^\w\-]+/g, '') // Remove all non-word chars
  .replace(/\-\-+/g, '-') // Replace multiple - with single -
  .replace(/^-+/, '') // Trim - from start of text
  .replace(/-+$/, ''); // Trim - from end of text
};

exports.createUniqueUuidFromString = createUniqueUuidFromString;
exports.slugify = slugify;


//////////////////
// WEBPACK FOOTER
// ../node_modules/pro-gallery-items-formatter/dist/src/utils.js
// module id = 411
// module chunks = 6 7 12 13 14 27